module.exports = "/assets/kropla-fdw.png?tgZZNT3";